import { FC, ReactNode } from 'react';
import { Typography } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

interface AdvancedSettingsViewHeaderProps {
    description: ReactNode;
    title: ReactNode;
}

const AdvancedSettingsViewHeader: FC<AdvancedSettingsViewHeaderProps> = ({ description, title }): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <div style={{ marginTop: '1rem' }}>
            <Typography.Title level={4}>{title}</Typography.Title>
            <Typography.Paragraph style={{ color: token.colorTextTertiary }}>{description}</Typography.Paragraph>
        </div>
    );
};

export default AdvancedSettingsViewHeader;
